// src/App.tsx

import { Navigate, createBrowserRouter, RouterProvider } from "react-router-dom";
import { DeviceMenuRefreshProvider } from "context/DeviceMenuRefreshContext";

import AuthenticationLayout from "layouts/AuthenticationLayout";
import SignIn from "./pages/auth/SignIn";
import ForgetPassword from "pages/auth/ForgetPassword";
import RootLayout from "layouts/RootLayout";
import NotFound from "pages/dashboard/pages/NotFound";
import Dashboard from "pages/dashboard/Index";
import UpdatePassword from "pages/auth/UpdatePassword";
import { useAuth } from "context/AuthContext";
import { UsersList } from "pages/admin/UsersPageList";
import { DevicesPageList } from "pages/admin/DevicesPageList";
import { DevicePage } from "pages/dashboard/devices/DevicePage";
import { ClientsPageList } from "pages/admin/ClientsPageList";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import ResetPassword from "pages/auth/ResetPassword";
import { TimezoneProvider } from "context/TimezoneContext";
import { TimerProvider } from "context/TimerContext";
import { ClientOverviewPage} from "pages/dashboard/clients/ClientsOverviewPage";
import { ClientReportsPage } from "pages/dashboard/clients/reports/ClientsReportPage";


const App = () => {
  const { isAuthenticated, isLoading } = useAuth(); 
  // console.log("🔍 App.tsx - isAuthenticated:", isAuthenticated, "isLoading:", isLoading);

  if (isLoading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        Loading...
      </div>
    );
  }

  const router = createBrowserRouter([
    {
      path: "/",
      // if not authenticated, redirect to sign-in
      element: isAuthenticated ? <RootLayout /> : <Navigate to="/auth/sign-in" replace />,
      errorElement: <NotFound />,
      children: [
        {
          index: true, // default child route
          element: <Dashboard />,
        },
        {
          id: "users",
          path: "/admin/users",
          Component: UsersList,
        },
        {
          id: "clients",
          path: "/admin/clients",
          Component: ClientsPageList,
        },
        {
          id: "devices",
          path: "/admin/devices",
          Component: DevicesPageList,
        },
        {
          path: "/client/:clientId/overview",
          element: <ClientOverviewPage />,
        },
        {
          path: "/client/:clientId/reports",
          element: <ClientReportsPage />,
        },
        {
          path: "/:device_name",
          element: <DevicePage />,
        },
        {
          path: "*",
          element: <NotFound />,
        }
      ],
    },
    {
      path: "/auth",
      element: <AuthenticationLayout />,
      children: [
        {
          index: true, // default child for /auth
          element: <Navigate to="sign-in" replace />,
        },
        {
          path: "sign-in",
          element: <SignIn />,
        },
        {
          path: "forget-password",
          element: <ForgetPassword />,
        },
        {
          path: "update-password", 
          element: <UpdatePassword />,
        },
        {
          path: "reset-password",
          element: <ResetPassword />,
        },
      ],
    },
  ]);

  return (
    <DeviceMenuRefreshProvider>
      <TimerProvider>
        <TimezoneProvider>
          <RouterProvider router={router} />
        </TimezoneProvider>    
      </TimerProvider>
    </DeviceMenuRefreshProvider>
  );
};

export default App;
